import { navigate } from '@reach/router';

import { IHoleRange } from '../../Utils/getHoleRange';

export interface IGoToNextHoleArgs {
  eventId: number;
  roundId: number;
  isShotgun: boolean;
  holeIndex: number;
  holesRange: IHoleRange;
  startingHole: number;
}

type TGoToNextHole = (args: IGoToNextHoleArgs) => void;

export const goToNextHole: TGoToNextHole = args => {
  const { eventId, roundId, isShotgun, holeIndex, holesRange, startingHole } = args;

  const baseRoute = `/event-scores/${eventId}/round/${roundId}`;

  if (isShotgun) {
    if (Number(holeIndex) === holesRange.length) {
      if (startingHole === null || startingHole === 0) {
        navigate(`${baseRoute}/complete`);
        return;
      }

      navigate(`${baseRoute}/hole/1/`);
      return;
    }

    if (Number(holeIndex) === startingHole) {
      navigate(`${baseRoute}/complete`);
      return;
    }

    navigate(`${baseRoute}/hole/${Number(holeIndex) + 1}/`);
    return;
  }

  if (holeIndex === holesRange.length) {
    navigate(`${baseRoute}/complete`);
    return;
  }

  if (Number(holeIndex) < holesRange.length) {
    navigate(`${baseRoute}/hole/${Number(holeIndex) + 1}/`);
    return;
  }
};
